import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-logging-in',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule
  ],
  templateUrl: './logging-in.component.html',
  styleUrl: './logging-in.component.scss'
})
export class LoggingInComponent {
  
}